/** What the pen line is doing. Each state is a different kind of waiting. */ /** States that play once and rest on their last frame. */ export const ONE_SHOT_STATES = new Set([
    "done",
    "failed"
]);
export const MID = 12;
// At button and inline sizes the fine line vanishes next to text, so small
// loaders draw a bolder mark that fills their box.
const COMPACT_MAX_SIZE = 24;
const REGULAR = {
    start: 4,
    end: 20,
    stroke: 1.2,
    dot: 2,
    track: 0.16
};
const COMPACT = {
    start: 2.5,
    end: 21.5,
    stroke: 2.6,
    dot: 3.2,
    track: 0.2
};
// thinking: the mark turns half a turn and rests; mid-turn the dots tuck this
// share of the way in towards the centre.
export const THINKING_LINE_OPACITY = 0.55;
export const THINKING_TUCK = 0.45;
// pondering: the line sits at this opacity while one stroke at a time drops onto
// it from rise above or below, shrinking from half its length as it lands.
export const PONDERING_LINE_OPACITY = 0.35;
export function thoughtFor(g) {
    return {
        rise: g.stroke > 2 ? 5.4 : 4.5,
        half: ((g.end - g.start) / 2 - g.dot - 1.2) * 0.8
    };
}
export function geometryFor(size) {
    return parseFloat(String(size)) <= COMPACT_MAX_SIZE ? COMPACT : REGULAR;
}
